<template>
  <g>
    <template v-for="(child, index) in root.children">
      <network-diagram-cable
        v-bind:key="root.id + '-' + child.id"
        v-bind:child-id="child.id"
        v-bind:dst-x="subtreeX"
        v-bind:dst-y="subtreeY(index)" />
      <g v-bind:transform="transform(index)"
        v-bind:key="child.id">
        <network-diagram-tree
          v-bind:network-id="networkId"
          v-bind:index="index"
          v-bind:root="child"
          v-on:tree-width-changed="onSubtreeWidthChange" />
      </g>
    </template>
    <network-diagram-node
      v-bind:id="root.id"
      v-bind:name="root.name"
      v-bind:status="root.status" />
  </g>
</template>

<script>
  import NetworkDiagramTree from './NetworkDiagramTree'
  import NetworkDiagramNode from './NetworkDiagramNode'
  import NetworkDiagramCable from './NetworkDiagramCable'

  export default {
    props: {
      networkId: String,
      index: Number,
      root: Object
    },
    components: { NetworkDiagramTree, NetworkDiagramNode, NetworkDiagramCable },
    data: function () {
      return {
        treeHeightUnit: 100,
        treeWidthUnit: 100,
        subtreeWidths: Array(this.root.children.length).fill(0)
      }
    },
    name: 'NetworkDiagramTree',
    watch: {
      subtreeWidths: function () {
        this.emitTreeWidthChangeEvent();
      }
    },
    created: function () {
      this.emitTreeWidthChangeEvent();
    },
    computed: {
      subtreeX: function () {
        return this.treeHeightUnit;
      },
      treeWidth: function () {
        if (this.subtreeWidths.length < 1) return this.treeWidthUnit;
        return this.sumOfSubtreeWidths(0, this.subtreeWidths.length);
      }
    },
    methods: {
      sumOfSubtreeWidths: function (start, end) {
        if (end - start < 1) return 0;
        return this.subtreeWidths.slice(start, end).reduce(function (p, c) { return p + c; });
      },
      subtreeY: function (index) {
        return this.sumOfSubtreeWidths(0, index);
      },
      transform: function (index) {
        return 'translate(' + this.treeHeightUnit + ',' + this.sumOfSubtreeWidths(0, index) + ')'
      },
      onSubtreeWidthChange: function (param) {
        this.subtreeWidths.splice(param.index, 1, param.treeWidth);
      },
      emitTreeWidthChangeEvent: function () {
        this.$emit('tree-width-changed', {
          index: this.index,
          treeWidth: this.treeWidth
        });
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>